import { LogIn } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { errorMessage } from '../api/client';
import { useAuth } from '../auth';
import { ErrorBanner } from '../components/Feedback';
import { Button, Field, Input } from '../components/Form';

export function LoginPage() {
  const { session, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const from = (location.state as { from?: string } | null)?.from ?? '/';

  if (!loading && session) return <Navigate to={from} replace />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-4 py-10">
      <div className="w-full max-w-sm space-y-4">
        <div className="flex items-center gap-3">
          <span className="grid size-9 place-items-center rounded-lg bg-sky-600 text-sm font-bold text-white">
            SR
          </span>
          <div>
            <h1 className="text-base font-semibold text-zinc-50">SMS Resale</h1>
            <p className="text-xs text-zinc-500">Панель администратора</p>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="space-y-3 rounded-xl border border-zinc-800 bg-zinc-900/50 p-4 shadow-lg shadow-black/30"
        >
          {error ? <ErrorBanner title="Вход не выполнен" message={error} /> : null}

          <Field label="Логин">
            <Input
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              required
              placeholder="admin"
            />
          </Field>

          <Field label="Пароль">
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
              placeholder="••••••••"
            />
          </Field>

          <Button
            type="submit"
            variant="primary"
            className="w-full"
            loading={busy}
            icon={<LogIn className="size-4" />}
          >
            Войти
          </Button>
        </form>

        <p className="text-center text-[11px] text-zinc-600">
          Сессия хранится в httpOnly-cookie и живёт 7 дней.
        </p>
      </div>
    </div>
  );
}
